import { Component, ElementRef, OnInit, ViewEncapsulation, signal } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { forkJoin, Observable, of, switchMap, timer } from 'rxjs';
import { USER_MGMT_DATA_CNST } from '../../../../constants/data.cnst';
import { USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../../../constants/table.cnst';
import { Config, Path } from '../../../../enums';
import { ROLE_NAME } from '../../../../enums/role.enum';
import { InitService } from '../../../../parsers/init.service';
import { AppStateService } from '../../../../services/app-state.service';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { BreadCrumsConstant } from '../../../../modules/shared/components/primeng-breadcrumb/breadcrumb.constants';
import { VlDataService } from '../../../../modules/shared/vl-data/vl-data.service';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { PrimengBreadcrumbComponent } from '../../../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { CustomPhoneNumberComponent } from '../../../../modules/shared/components/custom-phone-number/custom-phone-number.component';
import { IconBuilding, IconLayoutGrid, IconTrash, IconUserPlus } from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';
import { StepsModule } from 'primeng/steps';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { TreeSelectModule } from 'primeng/treeselect';
import { SelectModule } from 'primeng/select';
import { StepperModule } from 'primeng/stepper';
import { Select } from 'primeng/select';
import { ThemeService } from '@primeng/themes';





@Component({
  selector: 'lib-user-config',
  templateUrl: './user-config.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengBreadcrumbComponent,
    SkeletonModule,
    CustomPhoneNumberComponent,
    TablerIconComponent,
    ButtonModule,
    CardModule,
    ChipModule,
    InputTextModule,
    MultiSelectModule,
    RadioButtonModule,
    SelectModule,
    Select,
    StepperModule,
    StepsModule,
    ToastModule,
    TreeSelectModule,
    TablerIconComponent,
  ],providers:[
    provideTablerIcons({
      IconBuilding, IconLayoutGrid, IconTrash, IconUserPlus
    }),
  ]
})




export class UserConfigComponent implements OnInit {



  
  stepConfigB: {
    info: number,
    role: number,
    scope: number
  } = {
      info: 0,
      role: 1,
      scope: 2
    };
  currentTab: string = 'info';
  scopeValueList: any[] = [];

  activeStep: number = 0;

  //Constants
  constants = USER_MGMT_DEFAULT_CONFIG_CNST.ADD_USER_CONST;
  superAdmin: any = USER_MGMT_CNST.SUPER_ADMIN;
  dimensionType: any = USER_MGMT_CNST.DIMENSION_TYPE_CONST

  // Create/Update User Details
  userDetails: any;
  emailPattern: any = /^[a-zA-Z0-9](?!.*[_-]{2})[a-zA-Z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid: boolean = true;
  userId: any = null;
  userConfig = signal<any>(undefined);
  customerList: any;
  userForm: FormGroup = new FormGroup({});
  // Mobile Number Control
  isPrimaryMobileNoValid: boolean = true;
  currentCountryCode: string = "in";
  loader = signal(false);

  // Logged In User Details
  userPermission: any;
  userMetaInfo: any;
  isCustomer: any;
  operation: any = null;

  userDbSnapshot: any = {};

  //Edit User:: Role 
  roleForm: FormGroup = new FormGroup({});
  roles: any[] = [];
  filteredRoles: any[] = [];
  groupedRoles = signal<any[]>([]);
  selectedApplications: any = {};
  filterOptions: any = {}; // key: filterName, value: options.

  appIdMap: { [key: string]: any } = {}; // Application: ScopeEndPoint

  applications: any[] = [];

  addedRoles: any = 1;
  selectedProfiles: any = [];
  selectedCustomers: any = [];
  selected = [];

  currentRoleName: any = null;
  currentApplicationName: any = null;
  roleRemoved: boolean = false;
  scopeChildAvailable: boolean = false;

  customerName: any = null;
  customerId: any = null;
  userName: any = null;
  mobileNumber: any = null;
  email: any = null;
  updateInProcess: boolean = false;
  roleDetails: any[] = [];
  validScope: any = '';
  isUserNameValid: boolean = true;
  isScopeValid!: FormArray;
  items: { [key: string]: MenuItem[] } = BreadCrumsConstant

  customPhoneForm = new FormGroup({
    country: new FormControl<{ name: string; dial_code: string; code: string; flag: string } | null>(null, Validators.required),
    phoneNumber: new FormControl<string>('', [Validators.required, this.validatePhoneNumber.bind(this)])
  });
  selectedCountry!: { name: string; dial_code: string; code: string; flag: string; };
  customerAdministrator = ROLE_NAME.CUSTOMER_ADMINISTRATOR;
  filterOptionsBasedOnRole: any = {};
  isEdit: boolean = true ;

  isAddUpdateButtonClicked : boolean = false;

  constructor(
    private appState: AppStateService,
    private initSrv: InitService,
    private activatedRoute: ActivatedRoute,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private utilSrv: UtilsService,
    private envService: EnvService,
    private router: Router,
    private messageService: MessageService,
    private utilsService: UtilsService,
    private el: ElementRef,
    private dataService: VlDataService
  ) { }

//   initializeForms() {
//   this.roleForm = new FormGroup({
//     newRole: new FormControl('', Validators.required),
//     scope: new FormArray([]) // Initialize empty array
//   });
// }

roleSelected = ""


  ngOnInit(): void {

    this.roleForm = new FormGroup({
          newRole: new FormControl('', ),
          scope: new FormArray([])
        });
    
    // this.initializeForms();
    this.selectedCountry = USER_MGMT_DEFAULT_CONFIG_CNST.INITIAL_COUNTRY_DATA
    this.customPhoneForm.patchValue({
      country: this.selectedCountry,
      phoneNumber: ''
    });

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.operation = params['operation'];
      this.userId = params['userId'];
      let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
      this.userMetaInfo = localStorage.getItem("metaInfo")
      this.userMetaInfo = JSON.parse(this.userMetaInfo);
      this.isCustomer = !!(this.userMetaInfo && (this.userMetaInfo['customerId'] || this.userMetaInfo['customerName']));

      if (this.operation === USER_MODULE_OPERATIONS.ADD_USER) {
        this.userPermission = this.appState.getUserPermissions();
        this.addUserConfigaration();
        this.userForm = new FormGroup({
          firstName: new FormControl('', [Validators.required]),
          lastName: new FormControl('', [Validators.required]),
          username: new FormControl('', [Validators.required]),
          empId: new FormControl('', [Validators.required]),
          email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern), this.utilSrv.restrictedEmailCharactersValidator]),
        });
        this.loadRoles(); // Add this line

      } else if (this.operation === USER_MODULE_OPERATIONS.UPDATE_USER || this.operation === USER_MODULE_OPERATIONS.VIEW_USER) {
        this.editUserConfigaration();
        this.userForm = new FormGroup({
          firstName: new FormControl('', [Validators.required]),
          lastName: new FormControl('', [Validators.required]),
          status: new FormControl('Active', [Validators.required]),
          username: new FormControl('', [Validators.required]),
          empId: new FormControl('', [Validators.required]),
          email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern), this.utilSrv.restrictedEmailCharactersValidator]),
        });
        let a: keyof typeof this.stepConfigB;
        this.currentTab = params['config'];
        type StepConfigKeys = keyof typeof this.stepConfigB;

        // Ensure params['config'] is a valid key of stepConfig
        const configKey = params['config'];

        const currentTab = configKey as StepConfigKeys;
        this.activeStep = this.stepConfigB[currentTab];

        // this.roleForm = new FormGroup({
        //   newRole: new FormControl('', Validators.required),
        //   scope: new FormArray([])
        // });

        this.currentRoleName = params['roleName'];
        this.currentApplicationName = params['applicationName'];
        this.loadData();  
      }
    });
    this.updateBreadcrumb(this.operation);
  }

  ngAfterViewInit() {
    this.userTypeLoggedIn();
  }

  userTypeLoggedIn() {
    if (this.appState.getLoggedInUserType() === USER_MGMT_CNST.LOGGED_IN_USER_TYPES.superAdmin) {

      const listItems = this.el.nativeElement.querySelectorAll('ul > li');
      listItems.forEach((li: HTMLElement, index: number) => {
        const stepperAction = li.querySelector('.p-stepper-action');
        if (stepperAction && index === 2) {
          stepperAction.classList.add('disabled');
        }
      });
    }
  }

  updateBreadcrumb(operation: string) {
    if (this.items && this.items['userconfig']) {
      const label =
        operation === 'view' ? 'View Users' :
          operation === 'edit' ? 'Edit Users' :
            'Add Users'; // Default value
      // Ensure the second item exists; if not, add it
      if (this.items['userconfig'].length < 2) {
        this.items['userconfig'].push({ label, routerLink: '/usermgmt/users' });
      } else {
        // Update existing item at index 1
        this.items['userconfig'][1].label = label;
      }
      // Replace the array to ensure change detection
      this.items['userconfig'] = [...this.items['userconfig']];
    }
  }


  onToggleTab(tab: string, stepClick: any) {
    if (tab == 'scope' && this.scopeArray?.controls?.length <= 0) {
      return;
    }
    const tabs = Object.keys(this.stepConfigB);
    if (this.userId) {
      this.currentTab = tab;
      tabs.forEach((tabs: any) => {
        if (tabs === tab) {
          this.router.navigate(['usermgmt', 'users', 'config'], {
            queryParams: {
              config: tab
            },
            queryParamsHandling: 'merge'
          })
        }
      });
    }
  }

  initializeAddUserConfig(config: any) {
    return this.initSrv.loadConfig(config);
  }

  addUserConfigaration() {
    const config = {
      path: Path.ADD_USER_CONFIG_PATH,
      configType: Config.ADD_USER_CONFIG
    };
    this.initializeAddUserConfig(config).then((data: any) => {
      this.userConfig.set(data!.user);
      if (!this.isCustomer) {
        this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl)
          .subscribe({
            next: (response: any) => {
              const formattedResponse = this.formatCustomerList(response);
               this.customerList = formattedResponse;
              // this.customerList = this.dataSrv.addOptionsToTableData(formattedResponse, UM_TABLE_CNST.RESOURCES_LIST.customers);
            },
            error: () => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch customers list" });
            }
          });
      } else {
        this.customerList = [];
      }
    })
      .catch((err: any) => {
      });
  }


  editUserConfigaration() {
    const config = {
      path: Path.EDIT_USER_CONFIG_PATH,
      configType: Config.EDIT_USER_CONFIG
    }
    this.initializeAddUserConfig(config).then(async (data: any) => {
      this.userConfig.set(data!.user);
    }).catch((err: any) => {
    })
  }

  formatCustomerList(response: any) {
    let formattedCustomerList = [];

    for (let custId in response) {
      let customerInfo = response[custId];
      formattedCustomerList.push(customerInfo);
    }

    return formattedCustomerList;
  }

  //* move this logic to directive.
  onlyAlphabet(event: any) {
    const pattern = /[a-zA-Z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onlyLowerCaseAlphabet(event: any) {
    const pattern = /[a-z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onlyDigit(event: any) {
    const pattern = /[1-9]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilSrv.isEmailValid(this.emailPattern, inputStr);
  }

  onPaste(event: ClipboardEvent, key: any) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    let trimmedText = pastedText?.replace(/[^a-zA-Z]/g, '');
    setTimeout(() => {
      trimmedText = trimmedText?.substring(0, 25);
      this.userForm.patchValue({
        [key]: trimmedText
      });
    }, 1);
  }

  onUsernamePaste(_event: ClipboardEvent) {
    const pattern = /[a-z]*/;

    const inputChar: string | undefined = _event.clipboardData?.getData('text');
    const matchString = pattern.exec(inputChar as string)?.[0];
    if (matchString == inputChar) {
      const trimmedText = inputChar?.replace(/[^a-z]/g, '');
      this.isUserNameValid = true;
      const key: string = 'username';
      setTimeout(() => {
        this.userForm.patchValue({
          [key]: trimmedText
        });
      }, 1);
    } else {
      this.isUserNameValid = false;
      _event.preventDefault();
    }
  }

  resetField(event: any) {
    this.isPrimaryMobileNoValid = true;
    this.customPhoneForm.controls.phoneNumber.setValue(null);
    this.currentCountryCode = event.iso2;
  }

  checkLength(event: any) {
    let value = event.target.value;

    if (value.length > 0) {
      this.isPrimaryMobileNoValid = !this.customPhoneForm.invalid;
    } else {
      this.isPrimaryMobileNoValid = true;
    }
  }

  // Add user to db.
  handleAdd() {

    if (this.userForm.invalid) {
      //* handle errors.
      return;
    }
    //* Create post data for add user
    const postdata = this.postDataCreationForAddUser();
    this.loader.set(true);
    //* Api call for add user
    this.httpSrv.makePostApiCall('ADD_USER', postdata, this.envService.baseUrl).subscribe({
      next: (res: any) => {
        if (res.result) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User added successfully' })
          const userId = res.response;
          let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
          this.loader.set(false);
          this.router.navigate(['usermgmt', 'users', 'config'], {
            queryParams: {
              operation: USER_MODULE_OPERATIONS.UPDATE_USER,
              config: 'role',
              userId,
              applicationName: '-',
              roleName: '-'
            }
          })
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to create user" });
        }
      },
      error: (err: any) => {
        let { error } = err;
        this.loader.set(false);
        if (this.utilSrv.isObjectNotNullAndEmpty(error)) {
          let { message } = error;
          if (message) {
            if (message.includes('users_mobile_number_key')) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: "Mobile number already exists" });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
            }
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to create user" });
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to create user" });
        }
      }
    });
  }

  //* post data creation for add user
  postDataCreationForAddUser() {
    const postdata = {
      metaInfo: {
        "username": this.userForm.value.username,
        "firstName": this.userForm.value.firstName,
        "lastName": this.userForm.value.lastName,
        empId: this.userForm.value.empId,
        "email": this.userForm.value.email,
        "mobileNo": JSON.stringify(this.customPhoneForm.value),
        "customerId": this.userMetaInfo.customerId ?? null,
      }
    }
    return postdata;
  }

  // Edit User :: User Info 
  getUserInfoByUserId(userId: string): Promise<any> {
    return new Promise((resolve) => {
      if (userId) {
        const options = {
          uriParams: {
            userId
          }
        };
        this.httpSrv.makeGetApiCall('FETCH_USER_INFO_BY_ID', this.envService.baseUrl, options)
          .subscribe({
            next: (response: any) => {
              resolve(response.response.meta);
            },
            error: (error) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch user info" });
              resolve({});
            }
          });
      } else {
        resolve({});
      }
    });
  }

  

  // Edit User :: Load Roles For the User

  async loadData() {
    this.loader.set(true);
    this.userDetails = await this.getUserInfoByUserId(this.userId);
    if (this.userId) { 
      this.loadRoles(); 
    }
  }

  loadRoles() {
    this.filteredRoles = [];
    let userId = this.userId;
    let options = {
      uriParams: {
        userId: userId
      }
    }
    // Load Roles
    this.httpSrv.makeGetApiCall('LIST_OF_PROFILES_FOR_USER', this.envService.baseUrl, options).subscribe({
      next: (roles: any) => {
        this.roles = roles['response'] || [];
        this.loadScopeEndPoints();
        this.filteredRoles = this.roles.map(r => {
          if (r.roleDetailsJson?.validScopes) {
            r.roleDetailsJson.validScopes = r.roleDetailsJson.validScopes.map((s: any) => (
              { ...s, valuesLoaded: false, scopeValue: this.applications }
            ))
          }
          return r;
        });
        this.loader.set(false);
        this.groupRolesByApplication();
      },
      error: () => {
        this.loader.set(false);
        this.roles = [];
      }
    });
  }

  groupRolesByApplication(): void {
    const grouped = this.filteredRoles.reduce((acc, role) => {
      const group = acc.find((g: any) => g.applicationName === role.applicationName);
      if (group) {
        group.roles.push(role);
      } else {
        acc.push({
          applicationName: role.applicationName,
          applicationId: role.applicationId,
          roles: [role]
        });
      }
      return acc;
    }, []);
    this.groupedRoles.set(grouped);
  }

  loadScopeEndPoints() {
    this.appIdMap = {};
    this.httpSrv.makeGetApiCall("GET_APPLICATIONS_LIST", this.envService.baseUrl).subscribe({
      next: (apps: any) => {
        apps.forEach((app: any) => {
          this.appIdMap[app.applicationId] = app;
        })
        this.prepopulateUserData(this.userDetails);
      },
      error: (err: any) => {
      }
    });
  }


  onEditClick() {
    this.isEdit = true;
  }


    addUserConfig = {
  addUser: {
    addBtn: {
      title: 'Add'
    },
    cancelBtn: {
      title: 'Cancel'
    }
  }
};


//   getTitle(value: unknown): string {
//   return (value as any)?.title ?? '';
// }




  /**================== Scope Changes ======================== */
  get scopeArray(): FormArray {
    return this.roleForm.get("scope") as FormArray;
  }

  getFiltersOfRole(index: number): any[] {
    const roleId = this.getRoleIdFromScopeArray(index);

    if (!roleId) return [];
    const roleInfo = this.getRoleDetailsById(roleId);

    if (!roleInfo && !roleInfo.userRoleScope || !roleInfo.userRoleScope?.scope) return [];

    return roleInfo.userRoleScope.scope;
  }


  onNonHierarchyScopeChange(event: any, formIndex: number, filterIndex: number) {
    const selectedValues = event.value;

    const roleId = this.getRoleIdFromScopeArray(formIndex);

    const roleInfo = this.getRoleDetailsById(roleId);

    roleInfo.userRoleScope.scope[filterIndex].scopeValue = selectedValues;

  }

  onGeographyAndIntentScopeChange(formIndex: number, filterIndex: number) {

    const roleId = this.getRoleIdFromScopeArray(formIndex);

    const roleInfo = this.getRoleDetailsById(roleId);

    const scopeName = roleInfo.userRoleScope.scope[filterIndex].scopeName;

    let selectedNodeIDs = this.filterOptionsBasedOnRole[roleId][scopeName].map(function (obj: any) {
      return obj.value;
    });

    this.filterOptionsBasedOnRole[roleId][scopeName].forEach((item: any) => {
      if (item.children) {
        item.children.forEach((child: any) => {
          const index = selectedNodeIDs.indexOf(child.value);
          if (index !== -1) {
            selectedNodeIDs.splice(index, 1); // Remove the key if found
          }
        });
      }
    });
    roleInfo.userRoleScope.scope[filterIndex].scopeValue = selectedNodeIDs;
  }

  newRoleFormGroup(roleId: string, filters: any[]): FormGroup {
    // Build formControl obj.
    let formControls: {
      roleId: FormControl<any>
    } = {
      roleId: new FormControl(roleId, []),
    }

    // Build formControls for filters(scope) and push it to formControl Obj..
    filters.forEach(f => {
      if (f.scopeName) {
        // Filters are not required
        formControls[f.scopeName as keyof typeof formControls] = new FormControl([], []);
      }
    })

    // Build formgroup with roleId and filters and return it.
    return new FormGroup(formControls);
  }

  addRole(roleId: string = '') {
    this.isScopeValid = this.roleForm.get('scope') as FormArray;
    const newRoleId = roleId || this.roleForm.get('newRole')?.value;

    if (!this.scopeArray) {
    console.error('Scope form array not initialized');
    return;
  }




    if (!newRoleId) return;

    // Get role info
    const roleInfo = this.getRoleInfoById(newRoleId);

    if (roleInfo?.applicationId) {
      this.roleRemoved = false;
      this.selectedApplications[roleInfo.applicationId] = true;
    }

    // Get the filters for role.
    const filters = this.getValidScopeOfRole(newRoleId);

    if (filters.length > 0) {
      this.scopeValueList.push({});
    }

    // Find the list of filters for which we need to load the values.
    const loadValuesForFilters = filters.filter(f => {
      const filterId = this.getScopeId(f);
      if (filterId) {
        return !this.filterOptions[filterId];
      }
      return false;
    });

    this.loadFilterOptions(newRoleId, loadValuesForFilters, roleInfo?.applicationId);

    this.scopeArray.push(this.newRoleFormGroup(newRoleId, filters));

    // Filter the roles dropdown.
    this.filterRoles();

    // reset the new role value.
    this.roleForm.get('newRole')?.reset();
  }

  addNewScopeValue(rolescope: any) {
    this.scopeValueList.push({});
    const roleId = rolescope.value['roleId']
    const filters = this.getValidScopeOfRole(roleId);
    this.scopeArray.push(this.newRoleFormGroup(roleId, filters))
  }

  scopeValueSelected(scopeValuesList: any[], index: number, filter: any) {
    if (filter.scopeType == 'HIERARCHY') {
      const roleId = this.getRoleIdFromScopeArray(index);
      const roleInfo = this.getRoleInfoById(roleId);
      const hirerachy = roleInfo.roleDetailsJson.validScopes.find((scope: any) => scope['scopeType'] == 'HIERARCHY');
      const scopeValuesSelected = this.roleForm.get('scope')?.value[0][filter.scopeName];
      if (hirerachy) {
        if (hirerachy['scopeName'] == filter.scopeName) {
          for (let scopeValue of scopeValuesSelected) {
            const dependentValues = scopeValuesList.find((loc: any) => loc['label'] == scopeValue)['child'];
            this.scopeChildAvailable = true;
            this.filterOptions[filter.scopeName + '_' + scopeValue] = dependentValues;
            this.filterOptionsBasedOnRole[roleId] = this.dataService.deepClone(this.filterOptions);
            this.filterOptionsBasedOnRole[roleId] = this.dataService.deepClone(this.filterOptions);
          }
        } else {
          return
        }
      } else {
        return
      }
    }
  }

  removeScope(index: number) {
    const roleId = this.getRoleIdFromScopeArray(index);
    const roleInfo = this.getRoleInfoById(roleId);

    if (roleInfo) {
      this.roleRemoved = false;
      if (this.selectedApplications[roleInfo.applicationId]) {
        delete this.selectedApplications[roleInfo.applicationId];
      }
    } else {
      this.roleRemoved = true;
    }

    this.scopeArray.removeAt(index);
    this.filterRoles();
  }

  filterRoles() {
    // Filter the roles dropdown.
    this.filteredRoles = this.roles.filter(r => !this.selectedApplications[r.applicationId]);
    this.groupRolesByApplication();
  }

  getApplicationScopeEndPoint(appId: string) {
    if (!appId) return null;
    return this.appIdMap[appId] ? this.appIdMap[appId].scopeEndPoint : null;
  }

  getApplicationIdOfRole(roleId: string) {
    if (!roleId) return null;

    const roleInfo = this.roles.find(r => r.roleId === roleId);
    return roleInfo ? roleInfo.applicationId : null;
  }

  getScopeId(scope: any) {
    if (!scope) return null;

    return `${scope.scopeType}__${scope.scopeName}`;
  }

  getRoleIdFromScopeArray(index: number) {
    if (index == null || index == undefined) return null;

    if (!this.scopeArray.controls?.[index]) return null;

    return this.scopeArray.controls[index].get('roleId')?.value;
  }

  getRoleName(index: number): string {
    const roleId = this.getRoleIdFromScopeArray(index);

    if (!roleId) return '';
    let roleInfo = this.getRoleDetailsById(roleId);
    if (!roleInfo) {
      roleInfo = this.getRoleInfoById(roleId);
    }
    return roleInfo ? roleInfo.roleName + ' (' + roleInfo.applicationName + ")" : this.currentRoleName + ' (' + this.currentApplicationName + ")"
  }

  getRoleDetailsById(roleId: string) {
    return this.roleDetails.find(r => r.roleId === roleId);
  }

  getRoleInfoById(roleId: string) {
    return this.roles.find(r => r.roleId === roleId);
  }

  getValidScopeOfRole(roleId: string): any[] {
    const roleInfo = this.getRoleInfoById(roleId);
    if (!roleInfo) return [];

    if (!roleInfo.roleDetailsJson?.validScopes) return [];
    this.validScope = roleInfo.roleDetailsJson?.validScopes[0]?.scopeType;

    return roleInfo.roleDetailsJson.validScopes;
  }

  fetchScopeValuesForFilter(roleId: string, scope: any, applicationId: any): Observable<any> {
    if (!roleId || !scope) return of([]);

    // fetch application id of role.
    const applicationIdOfRole = this.getApplicationIdOfRole(roleId);
    if (!applicationIdOfRole) return of([]);

    // Fetch scope end point of application.
    const applicationScopeEndPoint = this.getApplicationScopeEndPoint(applicationIdOfRole);
    if (!applicationScopeEndPoint) return of([]);

    return this.httpSrv.makeGetApiCall('GET_SCOPE_VALUES_OF_TYPE', applicationScopeEndPoint, {
      replaceParams: {
        REPLACE_SCOPE_TYPE: scope.scopeType,
        REPLACE_SCOPE_NAME: scope.scopeName
      },
      headers: {
        CustomerId: this.customerId,
      },
      queryParams: {
        "application-uuid": applicationId
      }
    });
  }

  loadFilterOptions(roleId: any, filters: any, applicationId: any) {
    const promises: any = [];

    if(!this.filterOptionsBasedOnRole[roleId]) {
      this.filterOptionsBasedOnRole[roleId] = {};
    }
    filters.forEach((f: any) => {
      promises.push(this.fetchScopeValuesForFilter(roleId, f, applicationId));
    });
    forkJoin(promises).subscribe({
      next: (res: any) => {
        filters.forEach((f: any, i: any) => {
          res[i] = res[i]?.response;
          const data = res[i];
          if (f.scopeName === USER_MGMT_CNST.DIMENSION_TYPE_CONST.GEOGRAPHY || f.scopeName === USER_MGMT_CNST.DIMENSION_TYPE_CONST.INTENT) {
            const scopeName = String(this.getScopeId(f) ?? '');

             if(!this.filterOptionsBasedOnRole[roleId][scopeName]) {
              this.filterOptionsBasedOnRole[roleId][scopeName] = [];
             }
             this.filterOptionsBasedOnRole[roleId][scopeName] = this.addKeyInTheGeographicAndIntentOptions(data);
          } else {
            const filterOptions: any[] = data || [];
            this.filterOptions[this.getScopeId(f) as keyof typeof filterOptions] = filterOptions;
          }
        });
        this.filterOptionsBasedOnRole[roleId] = {
          ...this.filterOptionsBasedOnRole[roleId],
          ...this.dataService.deepClone(this.filterOptions)
        };
        this.getGeographyAndIntentData(roleId);
      },
      error: (err: any) => {
      }
    });
  }

  scopeSelectedHierachy(_event: any, scope: any) {
    const formData = this.roleForm.get('scope')?.value[_event];
    const roleInfo = this.getRoleInfoById(formData.roleId);
    const index = roleInfo.roleDetailsJson.validScopes.findIndex((s: any) => s['scopeName'] == scope['scopeName']);
    const scopeData = { ...roleInfo.roleDetailsJson.validScopes[index + 1] };
    this.filterOptions[this.getScopeId(scopeData) as keyof (typeof this.filterOptions)] = [];
    scopeData['scopeName'] = scopeData['scopeName'] + '_' + this.roleForm.get('scope')?.value[_event][scope['scopeName']]
    this.fetchScopeValuesForFilter(formData.roleId, scopeData, roleInfo?.applicationId).subscribe((data: any) => {
      scopeData['scopeName'] = scopeData['scopeName'].split('_')[0];
      const filterOptions: any[] = data || [];
      this.filterOptions[this.getScopeId(scopeData) as keyof typeof filterOptions] = filterOptions;
      this.filterOptionsBasedOnRole[formData.roleId] = this.dataService.deepClone(this.filterOptions);
    })
  }

  handleAutoCompleteSuggestions(index: number, filter: any) {
    if (!index || !filter) return;

    filter.scopeValue = ['Search'];
  }


//     getConfigTitle(config: any): string {
//   return config?.value?.title ?? '';
// }

// getConfigByKey(key: string): any {
//   return this.configs.find(c => c.key === key);
// }


// getEmailLabel(config: any): string {
//     return config?.value?.email?.label ?? this.constants?.placeHolder;
//   }

//   getConfigClass(config: any): string {
//   return (config?.value as any)?.class || this.constants?.addUser?.email?.class || '';
// }

// getUsernameLabel(config: any, key: ConfigKey): string {
//   return config?.value?.[key]?.label ?? this.constants?.placeHolder?.[key]?.label ?? '';
// }


// getFieldLabel(config: any, field: any): string {
//   return (config?.value as any)?.[field]?.label ?? this.constants?.placeHolder?.[field]?.label ?? '';
// }


// getLabel(config: any, key: ConfigKey): string {
//   return (config?.value as any)?.[key]?.label ?? this.constants?.placeHolder?.[key]?.label ?? '';
// }








  getKeyAsString(key: unknown): string {
  return String(key);
}


  /**============== End of scope changes ======================== */

  prepopulateUserData(data: any) {
    if (!data) return;
    this.userForm.disable();
    this.roleForm.disable();
    this.scopeArray.clear();

    let status: string;

    if (data.status != null) {
      status = data.status ? 'Active' : 'Inactive';
    } else {
      status = 'Active';
    }
    this.userForm.setValue({
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      email: data.email || '',
      username: data.username || '',
      empId: data.empId || '',
      status: status
    });


    let phoneNumberDetails = JSON.parse(data?.['mobileNo'] ?? '{}') ?? null
    this.customPhoneForm.patchValue({
      'country': phoneNumberDetails.country,
      'phoneNumber': phoneNumberDetails.phoneNumber
    })
    this.roleForm.setValue({
      newRole: null,
      scope: []
    })

    this.httpSrv.makeGetApiCall('GET_USER_PERMISSIONS', this.envService.baseUrl, { uriParams: { userId: data.userId } }).subscribe({
      next: (res: any) => {
        const metaInfo = res.response.meta;
        const permissions = res?.response?.permissions ? res.response.permissions : {};
        this.userDbSnapshot = res.response;

        if (Object.keys(metaInfo).length > 0) {
          let { username, mobileNo, customerId, email } = metaInfo;
          this.userName = username;
          this.mobileNumber = mobileNo;
          this.email = email;
          this.customerId = customerId;
        }

        let roles: any[] = [];
        for (let key in permissions) {
          let { applicationId, applicationName, roleId, roleName, userRoleScope } = permissions[key];
          roles.push({ applicationId, applicationName, roleId, roleName, userRoleScope });
        }
        this.roleDetails = roles;
        roles.forEach((r, i) => {
          this.selectedApplications[r.applicationId] = true;
          this.addRole(r.roleId);
          const scopeGroupValue: {
            roleId: any
          } = {
            roleId: r.roleId
          }
          if (r.userRoleScope?.scope) {
            r.userRoleScope.scope.forEach((s: any) => {
              if (s.scopeType == 'HIERARCHY') {
                let ind = 0;
                for (let rawValue of s.scopeValue) {
                  const value = JSON.parse(rawValue);
                  if (ind > 0) {
                    const roleValue = {
                      value: {
                        roleId: value['roleId']
                      }
                    };
                    this.addNewScopeValue(roleValue);
                  }
                  scopeGroupValue[value.roleId as keyof typeof scopeGroupValue] = value;
                  ind++;
                }
              } else {
                scopeGroupValue[s.scopeName as keyof typeof scopeGroupValue] = s.scopeType == 'NON_HIERARCHY' ? s.scopeValue : s.scopeValue[0];
                this.prepopulateFiltersOfRole(i, scopeGroupValue);
              }
            })
          }
        })
        if (this.operation != USER_MGMT_CNST.USER_MODULE_OPERATIONS.VIEW_USER) {
          this.userForm.enable();
          this.roleForm.enable();
        } else {
          this.scopeArray.disable();
        }
      },
      error: (err: any) => {
        if (this.operation != USER_MGMT_CNST.USER_MODULE_OPERATIONS.VIEW_USER) {
          this.userForm.enable();
          this.roleForm.enable();
        } else {
          this.scopeArray.disable();
        }
      }
    });
  }



  prepopulateFiltersOfRole(index: number, values: any) {
    if (index == null || index == undefined || !values?.roleId) return;

    if (this.scopeArray.controls.length <= index) return;

    for (let key in values) {
      if (this.scopeArray.controls[index].get(key)) {
        this.scopeArray.controls[index].get(key)?.setValue(values[key]);
        if (this.filterOptionsBasedOnRole[values?.roleId] && (key === this.dimensionType.GEOGRAPHY || key === this.dimensionType.INTENT)) {
          this.filterOptionsBasedOnRole[values?.roleId] = {
            ...this.filterOptionsBasedOnRole[values?.roleId],
            [key]: values[key] ? values[key] : []
          };
        }
      }
    }
    if (this.filterOptionsBasedOnRole[values?.roleId]?.['NON_HIERARCHY__GEOGRAPHY']) {
      this.setGeographyAndIntentData(this.scopeArray.controls[index].get(USER_MGMT_CNST.DIMENSION_TYPE_CONST.GEOGRAPHY)?.value, values?.roleId,USER_MGMT_CNST.DIMENSION_TYPE_CONST.GEOGRAPHY)
    } else if (this.filterOptionsBasedOnRole[values?.roleId]?.['NON_HIERARCHY__INTENT']) {
      this.setGeographyAndIntentData(this.scopeArray.controls[index].get(USER_MGMT_CNST.DIMENSION_TYPE_CONST.INTENT)?.value, values?.roleId,USER_MGMT_CNST.DIMENSION_TYPE_CONST.INTENT)
    }
  }

setGeographyAndIntentData(selectedNodeIds: any, roleId: any, scopeName: any) {
  selectedNodeIds = selectedNodeIds ?? [];
  this.filterOptionsBasedOnRole[roleId] = {
    ...this.filterOptionsBasedOnRole[roleId],
    [scopeName]: []
  };

  const nonHierarchyNodes = this.filterOptionsBasedOnRole[roleId]['NON_HIERARCHY__' + scopeName] ?? [];

  // Iterate through the non-hierarchy nodes to process selection
  nonHierarchyNodes.forEach((nodeData: any) => {
    if (selectedNodeIds.includes(nodeData['value'])) {
      // Add the parent node to the selected list
      this.filterOptionsBasedOnRole[roleId][scopeName].push(nodeData);
      nodeData['children']?.forEach((childNode: any) => {
        this.filterOptionsBasedOnRole[roleId][scopeName].push(childNode);

        // Recursively add child-of-child nodes
        this.addChildrenRecursively(childNode, roleId, scopeName);
      });
    } else  {
      // Process child nodes separately
      nodeData['children']?.forEach((childNode: any) => {
        if (selectedNodeIds.includes(childNode['value'])) {
          this.filterOptionsBasedOnRole[roleId][scopeName].push(childNode);
          this.addChildrenRecursively(childNode, roleId, scopeName);
        } else {
          if (childNode?.children) {
            childNode.children.forEach((childNode: any) => {
              if(selectedNodeIds.includes(childNode['value']))
              this.filterOptionsBasedOnRole[roleId][scopeName].push(childNode);
            });
          }
        }
        
      });
    }
  });

  // Mark nodes as partially selected where applicable
  this.makePartialSelectedTrueInGeographyAndIntent(roleId, scopeName);
}

// Recursive function to process child-of-child nodes
addChildrenRecursively(node: any, roleId: any, scopeName: any) {
  if (node?.children) {
    node.children.forEach((childNode: any) => {
      this.filterOptionsBasedOnRole[roleId][scopeName].push(childNode);
    });
  }
}


  prepopulateFilterofRoleForHierarchy(index: number, values: any) {
    if (!values?.roleId) return;
    for (let scope in values) {
      let i = 0;
      for (let key in values[scope]) {
        if (this.scopeArray.controls[(index)].get(key)) {
          if (i > 0) {
            const roleData = this.roles.find((role: any) => role['roleId'] == scope);
            this.scopeSelectedHierachy(index, roleData.roleDetailsJson.validScopes[0]);
          }
          this.scopeArray.controls[index].get(key)?.setValue(values[scope][key]);
        }
        i++;
      }
    }
  }

  handleUpdate() {
    if (this.userForm.invalid) {
      return;
    }

    this.isAddUpdateButtonClicked = true;

    const updatedUserInfo = this.userForm.getRawValue();
    const userInfo = { ...this.userDetails, email: this.userDetails.email };

    const scope = this.parseScope(this.roleForm.value.scope);
    const userRoleMapping = this.buildUserRoleMapping(scope);

    const { addRoles, updateRoles, deleteRoles } = this.compareRoles(userRoleMapping);

    const metaInfo = this.buildMetaInfo(updatedUserInfo, userInfo);

    const postData = {
      metaInfo,
      addRoles,
      updateRoles,
      deleteRoles,
      userId: this.userId,
    };

    this.updateUser(postData, userInfo);
  }

  parseScope(scope: any): any {
    return typeof scope === 'string' ? JSON.parse(scope) : scope || [];
  }

  buildUserRoleMapping(scope: any[]): any {
    const userRoleMapping: any = {};
    let breakLook = false;

    scope.forEach((s) => {
      const roleId = this.getRoleId(s);
      userRoleMapping[roleId] = userRoleMapping[roleId] || {};

      let filtersOfRole = this.getValidScopeOfRole(roleId);
      if (this.currentTab == 'scope') {
        const roleInfo = this.getRoleDetailsById(roleId);
        filtersOfRole = roleInfo.userRoleScope.scope;
      }


      let scopeData = this.setScopeDataToRole(filtersOfRole, s.roleId);

      userRoleMapping[roleId].scope = userRoleMapping[roleId].scope || [];
      userRoleMapping[roleId].scope = userRoleMapping[roleId].scope.concat(scopeData);

      if (this.shouldBreakLoop(scopeData)) {
        breakLook = true;
      }

      if (breakLook) return;
    });

    return userRoleMapping;
  }

  getRoleId(s: any): string {
    return typeof s === 'string' ? JSON.parse(s).roleId : s.roleId;
  }


  shouldBreakLoop(scopeData: any[]): boolean {
    return scopeData.some((data) => data.scopeType === 'HIERARCHY');
  }

  compareRoles(userRoleMapping: any): { addRoles: any, updateRoles: any, deleteRoles: any[] } {
    const existingPermissions = this.userDbSnapshot.permissions || {};
    const existingRolesOfUser: any = {};
    Object.values(existingPermissions).forEach((p: any) => (existingRolesOfUser[p.roleId] = p));

    const addRoles: any = {};
    const updateRoles: any = {};
    const deleteRoles: any[] = [];

    for (const role in userRoleMapping) {
      if (existingRolesOfUser[role]) {
        updateRoles[role] = userRoleMapping[role]
      } else {
        addRoles[role] = userRoleMapping[role];
      }
    }

    for (const role in existingRolesOfUser) {
      if (!userRoleMapping[role]) {
        deleteRoles.push(role);
      }
    }

    return { addRoles, updateRoles, deleteRoles };
  }



  buildMetaInfo(updatedUserInfo: any, userInfo: any): any {
    if (this.getMetaInfoStr(updatedUserInfo) !== this.getMetaInfoStr(userInfo)) {
      return {
        ...updatedUserInfo,
        mobileNo: JSON.stringify(this.customPhoneForm.value),
      };
    }
    return null;
  }

  setScopeDataToRole(filtersOfRole: any[], roleId: string) {
    let scopeData: any = [];
    for (let filter of filtersOfRole) {
      if (filter.scopeType == 'HIERARCHY') {
        const scopeValue = {
          roleId: roleId,
          Customer: [],
          CUSTOMER_TIER: []
        }
        const scopeObj = {
          scopeType: filter.scopeType,
          scopeValue: [JSON.stringify(scopeValue)]
        }
        scopeData = [scopeObj];
        break;
      } else {
        const scopeObj = {
          scopeType: filter.scopeType,
          scopeName: filter.scopeName,
          scopeValue: filter.scopeValue
        }
        scopeData.push(scopeObj);
      }
    };

    return scopeData;
  }

  updateUser(postdata: any, userInfo: any) {
    if (this.updateInProcess) return;
    
    setTimeout(() => {
      this.isAddUpdateButtonClicked = false
    }, 2000);

    this.updateInProcess = true;
    this.loader.set(true);
    if (postdata['metaInfo']) {
      postdata['metaInfo']['status'] = postdata['metaInfo']['status'] === USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE;
    }
    const { userId = '', operation, ...rest } = postdata;
    this.httpSrv.makePutApiCall('UPDATE_USER', rest, this.envService.baseUrl, { uriParams: { userId } }).pipe(
      switchMap((res: any) => {
        this.updateInProcess = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: USER_MGMT_DATA_CNST.TOASTER_MSG.UPDATE_USER });
        // Return an observable that emits after 1000ms delay
        return timer(1000);
      })
    ).subscribe({
      next: () => {
        this.loader.set(false);
        const scopeValue = this.roleForm.get('scope')?.value;
        if (this.activeStep === 0) {
          this.router.navigate(['usermgmt', 'users', 'config'], {
            queryParams: { config: 'role', userId: this.userId },
            queryParamsHandling: 'merge'
          });
        } else if (this.activeStep === 1) {
          this.router.navigate(['usermgmt', 'users']);
        } else {
          const targetRoute = scopeValue && scopeValue.length > 0
            ? ['usermgmt', 'users', 'config']
            : ['usermgmt', 'users'];

          const queryParams = scopeValue && scopeValue.length > 0
            ? { config: 'scope' }
            : undefined;

          if (this.appState.getLoggedInUserType() !== USER_MGMT_CNST.LOGGED_IN_USER_TYPES.superAdmin) {
            this.router.navigate(targetRoute, {
              queryParams,
              queryParamsHandling: 'merge'
            });
          } else {
            this.router.navigate(['usermgmt', 'users']);
          }
        }
      },
      error: (err: any) => {
        this.updateInProcess = false;
        this.loader.set(false);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message });
      }
    });
  }


  getMetaInfoStr(userInfo: any) {
    if (!userInfo) return '';

    return JSON.stringify({
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      email: userInfo.email,
      status: userInfo.status
    })
  }

  navigateToUsers() {
    this.router.navigate(['usermgmt', 'users']);
  }

  hasHierarchyFilters(index: number): boolean {
    const filters = this.getFiltersOfRole(index);
    return filters.some(filter => filter.scopeType === 'HIERARCHY');
  }

  hasNonHierarchyFilters(index: number): boolean {
    const filters = this.getFiltersOfRole(index);
    return filters.some(filter => filter.scopeType === 'NON_HIERARCHY');
  }

  formatGeographyValues(geographyValues: any[]) {
    if (Array.isArray(geographyValues)) {
      geographyValues.forEach((value: any) => {
        value.disabled = false;
      })
    }
    return geographyValues ?? []
  }


  isElementDisabled(type: string): boolean {
    this.utilSrv.disableStepper(this.roleForm.get('scope')?.value.length !== 0)
    if (type === 'user') {
      return this.userForm.invalid;
    } else {
      return this.roleForm.invalid;
    }
  }


  validatePhoneNumber(control: FormControl): { [key: string]: boolean } | null {
    return null;
    // const country = this.customPhoneForm?.get('country')?.value;
    // return this.utilsService?.validateMobileNumber(control, country);
  }


  onCountryChange(event: any) {
    this.customPhoneForm.patchValue({
      country: event?.value,
      phoneNumber: ''
    });
  }

  // addKeyInTheGeographicAndIntentOptions(data: any) {
    addKeyInTheGeographicAndIntentOptions(data: any[]): any[] {
      const addKey = (obj: any): any => ({
        ...obj,
        key: obj.value, // Add key at the current level
        children: obj.children?.map((child: any) => addKey(child)) || [], // Recursively handle nested children
      });
     
      return data.map((obj: any) => addKey(obj));
    }
  // }

  removeNode(node: any, formIndex: number, filterIndex: number, event: any): void {

    event.stopPropagation();
    const removedNodeIds = new Set<string>();

    // Add the node itself to the removal set
    removedNodeIds.add(node.value);

    const roleId = this.getRoleIdFromScopeArray(formIndex);

    const roleInfo = this.getRoleDetailsById(roleId);

    const scopeName = roleInfo.userRoleScope.scope[filterIndex].scopeName;

    // If the node has children, add all children's values to the set
    if (node.children) {
      node.children.forEach((child: any) => removedNodeIds.add(child.value));
    } else {
      // If it's a child node, find and add its parent's value to the set
      this.filterOptionsBasedOnRole[roleId]['NON_HIERARCHY__'+scopeName].forEach((parent: any) => {
        if (parent.children.some((child: any) => child.value === node.value)) {
          removedNodeIds.add(parent.value);
        }
      });
    }

  

    // Filter the selected nodes to exclude those in the removal set
    this.filterOptionsBasedOnRole[roleId][scopeName] = this.filterOptionsBasedOnRole[roleId][scopeName].filter(
      (n: any) => !removedNodeIds.has(n.value)
    );
    this.makePartialSelectedTrueInGeographyAndIntent(roleId,scopeName)

    roleInfo.userRoleScope.scope[filterIndex].scopeValue = this.filterOptionsBasedOnRole[roleId][scopeName].map(function (obj: any) {
      return obj.value;
    });
  }

  isObjectEmpty(obj: object | undefined | null): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  getGeographyAndIntentData(roleId: any) {
    this.scopeArray.controls.forEach((formG: any) => {
      if (formG.get('roleId')?.value === roleId) {
        [USER_MGMT_CNST.DIMENSION_TYPE_CONST.GEOGRAPHY,USER_MGMT_CNST.DIMENSION_TYPE_CONST.INTENT].forEach((dimension:any)=>{
          if(typeof(formG.get(dimension)?.value?.[0]) === 'string') {
            this.setGeographyAndIntentData(formG.get(dimension)?.value, formG.get('roleId')?.value,dimension);
          }
        })
      }
    })
  }

  makePartialSelectedTrueInGeographyAndIntent(roleId: any, scopeName: any) {
    const parentIDs: Set<string> = new Set();
  
    // Collect parent IDs from nodes with children
    this.filterOptionsBasedOnRole[roleId]?.[scopeName]?.forEach((node: any) => {
      if (node?.children && node.children.length > 0) {
        parentIDs.add(node.value); // Add parent ID to the set
      }
    });
  
    // Helper function to check if a parent node has partially selected children
    const isPartialSelected = (parentNode: any): boolean => {
      if (!parentNode?.children) return false;
  
      let hasSelectedChild = false;
      let hasUnselectedChild = false;
  
      parentNode.children.forEach((child: any) => {
        if (child.selected) {
          hasSelectedChild = true;
        }
        if (!child.selected) {
          hasUnselectedChild = true;
        }
        // Recursively check child-of-child
        if (child.children) {
          if (isPartialSelected(child)) {
            hasSelectedChild = true;
            hasUnselectedChild = true;
          }
        }
      });
  
      // A parent is partially selected if it has both selected and unselected children
      return hasSelectedChild && hasUnselectedChild;
    };
  
    // Traverse all nodes and set `partialSelected` for parent nodes
    this.filterOptionsBasedOnRole[roleId]?.[scopeName]?.forEach((node: any) => {
      if (node?.children && parentIDs.has(node.value)) {
        node.partialSelected = isPartialSelected(node); // Recursively check for partial selection
      }
    });
  }

  setData(event: any, item: any, index: any, key: string) {

    event.stopPropagation();

    // Filter out the item and update the FormArray value
    const tempData = this.scopeArray.controls[index].value[key]?.filter(
      (data: any) => data !== item['value']
    );

    // Update the FormControl value with the filtered data
    this.scopeArray.controls[index].get(key)?.setValue(tempData || []);
  }




}